// enums/flow-mode.enum.ts
export enum FlowMode {
    CREATE = 'CREATE',
    EDIT = 'EDIT',
    RESUME = 'RESUME'
}
